export default __webpack_public_path__ + "media/images/placeholders/brown-background-d61dd4aced68f7d58d0c5aaeef22f633.jpg";